import cx from "classnames";
import React from "react";

import { dummyPhoto } from "@/mk2/apps/strollers/constants";
import { StrollerEntity } from "@/mk2/apps/strollers/schemas";
import { strollersDetailUrl } from "@/mk2/apps/strollers/urls";
import { Clamp } from "@/mk2/components/Clamp";
import { ImgCropMode, ImgCropped } from "@/mk2/components/ImgCropped";
import { Link } from "@/mk2/components/Link";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { url } from "@/mk2/helpers/urls";
import { getLogger } from "@/mk2/logger";

import styles from "./ReviewStrollerPreview.mscss";

interface OwnProps {
    stroller: StrollerEntity;
    className?: string;
    style?: React.CSSProperties;
}

type Props = OwnProps;

export default class ReviewStrollerPreview extends React.Component<Props> {
    public render() {
        const logger = getLogger("ReviewStrollerPreview");
        logger.error();

        const { stroller, className, style } = this.props;
        const photo = stroller.previewPhoto || dummyPhoto;
        return (
            <Link
                to={url(strollersDetailUrl, { slug: stroller.slug })}
                className={cx(styles.ReviewStrollerPreview, className)}
                style={style}
            >
                <div className={styles.ReviewStrollerPreview__headline}>
                    <div className={styles.ReviewStrollerPreview__image}>
                        <ImgCropped
                            className={styles.ReviewStrollerPreview__image__img}
                            width={64}
                            height={64}
                            mode={ImgCropMode.Cover}
                            imgUrl={photo.url100x100}
                            imgWidth={64}
                            imgHeight={64}
                            lazy
                        />
                    </div>
                    <div className={styles.ReviewStrollerPreview__rightColumn}>
                        <div className={styles.ReviewStrollerPreview__title}>
                            <h3>
                                <Clamp clamp={2}>
                                    <div>{stroller.name}</div>
                                </Clamp>
                            </h3>
                        </div>
                    </div>
                </div>
                <div className={styles.ReviewStrollerPreview__perex}>
                    <Clamp clamp={3}>
                        <div />
                    </Clamp>
                    <div className={styles.ReviewStrollerPreview__perex__mask} />
                </div>
            </Link>
        );
    }
}

interface PlaceholderOwnProps {
    className?: string;
    style?: React.CSSProperties;
}

export const ReviewStrollerPreviewPlaceholder = React.memo<PlaceholderOwnProps>(
    ({ className, style }) => {
        return (
            <div className={cx(styles.ReviewStrollerPreview, className)} style={style}>
                <div className={styles.ReviewArticlePreview__headline}>
                    <div className={styles.ReviewArticlePreview__image}>
                        <LoadingPlaceholder
                            width={64}
                            height={64}
                            className={styles.ReviewArticlePreview__image__img}
                        />
                    </div>
                    <div className={styles.ReviewArticlePreview__rightColumn}>
                        <div className={styles.ReviewArticlePreview__title}>
                            <LoadingPlaceholder width={280} height={22} />
                        </div>
                        <div className={styles.ReviewArticlePreview__rightColumn__stats}>
                            <LoadingPlaceholder width={88} height={17} />
                            &nbsp;&nbsp;
                            <LoadingPlaceholder width={150} height={17} />
                        </div>
                    </div>
                </div>
                <div className={styles.ReviewStrollerPreview__perex}>
                    <LoadingPlaceholder width={"100%"} height={57} />
                    <div className={styles.ReviewStrollerPreview__perex__mask} />
                </div>
            </div>
        );
    },
);

ReviewStrollerPreviewPlaceholder.displayName = "ReviewStrollerPreviewPlaceholder";
